import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { ChangePasswordService } from '../../services/change-password.service';
import { AuthService } from '@bya/auth/services/authentication.service';
import { changePasswordUser } from '../../models/change-password-user';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class ChangePasswordModalComponent {

  constructor
  (
    public matDialogRef: MatDialogRef<ChangePasswordModalComponent>,
    private _formBuilder: FormBuilder,
    private _matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _changePasswordService:ChangePasswordService,
    private _authService:AuthService
  ) 
  { 
    this.ChangePasswordForm = this.createChangePasswordForm();
  }

  ChangePasswordForm: FormGroup;

  public CambiarContrasenia():void{
    let cargando = this._matDialog.open(LoadingComponent).addPanelClass("loading");
    let request = new changePasswordUser();
    request = this.ChangePasswordForm.value;
    request.Username = this._authService.name;
    this._changePasswordService.postChangePassword(request)
    .subscribe(response =>{
      cargando.close();
      if(response){
        if(response.isValid){
          this._snackBar.open(response.mensaje);
          this.matDialogRef.close();
        }
      }
    });
  }
  
  private createChangePasswordForm(): FormGroup {
    return this._formBuilder.group({
      currentPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      newPasswordConfirm: [null, [Validators.required, confirmPasswordValidator]],
    });
  }
}

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  if (!control.parent || !control) {
      return null;
  }

  const password = control.parent.get('newPassword');
  const passwordConfirm = control.parent.get('newPasswordConfirm');

  if (!password || !passwordConfirm) {
      return null;
  }

  if (passwordConfirm.value === '') {
      return null;
  }

  if (password.value === passwordConfirm.value) {
      return null;
  }

  return { passwordsNotMatching: true };
};